import service from "@/utils/service"

//获取用户列表,无参数时查询所有
export function getDomainList(data) {
  return service({
    url: "/inquiry/domain/view",
    method: "post",
    data: data
  })
}

//添加用户
export function createDomain(data) {
  return service({
    url: "/inquiry/domain/add",
    method: "post",
    data: data
  })
}

//编辑用户信息
export function updateDomain(data) {
  return service({
    url: "/inquiry/domain/edit",
    method: "post",
    data: data
  })
}

//删除用户
export function deleteDomain(data) {
  return service({
    url: "/inquiry/domain/del",
    method: "post",
    data: data
  })
}

//批量删除
export function batchDeleteDomain(data) {
  return service({
    url: "/inquiry/domain/batchdelete",
    method: "post",
    data: data
  })
}
//获取所有用户名
export function getOwnerOptions() {
  return service({
    url: "/inquiry/domain/getowneroptions",
    method: "get"
  })
}
